/**
 * Convert kebab-case or separate words to camelCase
 */
export const toCamelCase = (str: string): string =>
  str
    .replace(/-/g, ' ')
    .replace(/\s(.)/g, (value) => value.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, (value) => value.toLowerCase());

export type ReplaceParams = Array<string | number> | { [key: string]: string | number };
